// Main JavaScript file for Orgure Website Interactive Features

document.addEventListener('DOMContentLoaded', () => {
  // --- Cart Drawer Logic ---
  const cartToggleBtns = document.querySelectorAll('[data-cart-toggle]');
  const cartDrawer = document.getElementById('cart-drawer');
  const cartOverlay = document.getElementById('cart-overlay');
  const cartCloseBtn = document.getElementById('cart-close');
  const cartBadge = document.getElementById('cart-badge');
  const addToBasketBtns = document.querySelectorAll('[data-add-to-cart]');

  let cartCount = 1; // Default 1 item in basket

  function openCart() {
    if (cartDrawer) {
      cartDrawer.classList.remove('drawer-closed');
      cartDrawer.classList.add('drawer-open');
      document.body.style.overflow = 'hidden';
    }
  }

  function closeCart() {
    if (cartDrawer) {
      cartDrawer.classList.remove('drawer-open');
      cartDrawer.classList.add('drawer-closed');
      document.body.style.overflow = '';
    }
  }

  cartToggleBtns.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      openCart();
    });
  });

  if (cartCloseBtn) cartCloseBtn.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  // Add to Cart Buttons
  addToBasketBtns.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      cartCount++;
      if (cartBadge) {
        cartBadge.textContent = cartCount;
        cartBadge.classList.remove('hidden');
      }
      
      // Temporary button state effect
      const originalText = btn.innerHTML;
      btn.innerHTML = '<span class="material-symbols-outlined text-sm mr-1">check</span> Added';
      btn.classList.add('bg-forest-leaf', 'text-white');
      
      setTimeout(() => {
        btn.innerHTML = originalText;
        btn.classList.remove('bg-forest-leaf', 'text-white');
      }, 1500);

      // Open cart drawer after adding item
      setTimeout(() => {
        openCart();
      }, 300);
    });
  });

  // --- Mobile Navigation Menu Logic ---
  const mobileMenuToggle = document.getElementById('mobile-menu-toggle');
  const mobileMenu = document.getElementById('mobile-menu');

  if (mobileMenuToggle && mobileMenu) {
    mobileMenuToggle.addEventListener('click', () => {
      mobileMenu.classList.toggle('hidden');
    });
  }

  // --- Order Tracking Sanctuary Logic ---
  const trackOrderForm = document.getElementById('track-order-form');
  const trackOrderResult = document.getElementById('track-order-result');

  if (trackOrderForm && trackOrderResult) {
    trackOrderForm.addEventListener('submit', (e) => {
      e.preventDefault();
      const orderIdInput = document.getElementById('order-id-input');
      const orderId = orderIdInput ? orderIdInput.value.trim() : 'ORG-9842';

      trackOrderResult.classList.remove('hidden');
      trackOrderResult.innerHTML = `
        <div class="p-4 bg-cream-canvas border border-sand-border rounded-lg text-left text-sm space-y-2">
          <div class="flex items-center justify-between font-semibold text-forest-deep">
            <span>Order #${orderId || 'ORG-9842'}</span>
            <span class="px-2 py-0.5 text-xs bg-emerald-100 text-emerald-800 rounded-full">In Transit</span>
          </div>
          <p class="text-text-muted">Despatched from Assam Gaushala via Eco Express</p>
          <div class="w-full bg-sand-warm h-2 rounded-full overflow-hidden mt-2">
            <div class="bg-forest-deep h-full w-3/4 rounded-full"></div>
          </div>
          <p class="text-xs text-secondary italic">Expected Delivery: 2 Days (Harvest Fresh)</p>
        </div>
      `;
    });
  }

  // --- Vedic Vaidya Chat Help Floating Widget ---
  const vaidyaToggleBtn = document.getElementById('vaidya-chat-toggle');
  const vaidyaModal = document.getElementById('vaidya-chat-modal');
  const vaidyaCloseBtn = document.getElementById('vaidya-chat-close');

  if (vaidyaToggleBtn && vaidyaModal) {
    vaidyaToggleBtn.addEventListener('click', () => {
      vaidyaModal.classList.toggle('hidden');
    });
  }

  if (vaidyaCloseBtn && vaidyaModal) {
    vaidyaCloseBtn.addEventListener('click', () => {
      vaidyaModal.classList.add('hidden');
    });
  }

  // Close modals on Escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeCart();
      if (vaidyaModal) vaidyaModal.classList.add('hidden');
      if (mobileMenu) mobileMenu.classList.add('hidden');
    }
  });
});
